import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Input = forwardRef(({
    id,
    type = 'text',
    label,
    placeholder = '',
    className = '',
    error = '',
    disabled = false,
    ...props
}, ref) => {
    const inputId = id || `input-${label.replace(/\s+/g, '-').toLowerCase()}`;

    const baseInputClasses = 'block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border appearance-none focus:outline-none focus:ring-0 peer';
    const baseInputStateClasses = error
        ? 'border-red-600 focus:border-red-600'
        : 'border-gray-400 focus:border-blue-700';
    const baseLabelClasses = 'absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1';
    const baseLabelStateClasses = error
        ? 'text-red-600 peer-focus:text-red-600'
        : 'text-gray-500 peer-focus:text-blue-600';


    const removeNumberSpinners = `
    [type='number']::-webkit-inner-spin-button,
    [type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    [type='number'] {
      -moz-appearance: textfield;
    }
  `;


    return (
        <div className="relative w-full">
            <input
                type={type}
                id={inputId}
                className={`${baseInputClasses} ${baseInputStateClasses} ${className}`}
                placeholder=" "
                ref={ref}
                aria-invalid={error ? 'true' : 'false'}
                aria-describedby={error ? `${inputId}-error` : undefined}
                disabled={disabled}
                {...props}
            />
            <label
                htmlFor={inputId}
                className={`${baseLabelClasses} ${baseLabelStateClasses}`}
            >
                {label}
            </label>
            {error && (
                <p id={`${inputId}-error`} className="mt-2 text-xs text-red-600">
                    {error}
                </p>
            )}
            <style>{removeNumberSpinners}</style>
        </div>
    );
});

Input.displayName = 'Input';

Input.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.string,
};

export default Input;
